import React from "react";
import { MapPin } from "lucide-react";

const LocationsSection = () => {
  const locations = [
    { name: "Morehead City", state: "NC" },
    { name: "New Bern", state: "NC" },
    { name: "Jacksonville", state: "NC" },
    { name: "Sneads Ferry", state: "NC" },
    { name: "Emerald Isle", state: "NC" },
    { name: "Indian Beach", state: "NC" },
    { name: "Orlando", state: "FL" },
    { name: "Tampa", state: "FL" },
    { name: "Pensacola", state: "FL" },
    { name: "Jacksonville", state: "FL" },
    { name: "Panama City", state: "FL" }
  ];

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-block">
            <div className="h-1 w-16 bg-blue-600 mb-4 mx-auto"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Our Locations</h2>
          <div className="max-w-3xl mx-auto">
            <p className="text-lg text-gray-600 leading-relaxed mb-4">
              We proudly serve multiple locations across <span className="font-semibold text-gray-900">North Carolina and Florida</span>, 
              delivering professional epoxy flooring services with quality craftsmanship, reliability, and attention to detail.
            </p>
          </div>
        </div>

        {/* North Carolina Locations */}
        <div className="mb-10">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-6">North Carolina</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-6xl mx-auto">
            {locations.filter(loc => loc.state === "NC").map((location, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 text-center"
              >
                <MapPin className="w-8 h-8 text-blue-600 mx-auto mb-3" />
                <p className="font-semibold text-gray-900">{location.name}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Florida Locations */}
        <div>
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-6">Florida</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 max-w-5xl mx-auto">
            {locations.filter(loc => loc.state === "FL").map((location, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 text-center"
              >
                <MapPin className="w-8 h-8 text-blue-600 mx-auto mb-3" />
                <p className="font-semibold text-gray-900">{location.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;